import FormBuilderConfig from "../../../toolkit/baseForms2/formBuilder/FormBuilder.config";
import ISelectBuilder from "../../../toolkit/baseForms2/iSelectBuilder/ISelectBuilder";
import ITextBuilder from "../../../toolkit/baseForms2/iTextBuilder/ITextBuilder";
import IButtonBuilder from "../../../toolkit/baseForms2/iButtonBuilder/IButtonBuilder";

export type Inputs = "mes" | "anio" | "folioFactura" | "tipoBusqueda";
export type Buttons = "buscar";

const currentYear = new Date().getFullYear();
const years = Array.from({ length: 2 }, (_, i) => currentYear - 1 - i);

const monthOptions = [
  { value: "01", label: "Enero" },
  { value: "02", label: "Febrero" },
  { value: "03", label: "Marzo" },
  { value: "04", label: "Abril" },
  { value: "05", label: "Mayo" },
  { value: "06", label: "Junio" },
  { value: "07", label: "Julio" },
  { value: "08", label: "Agosto" },
  { value: "09", label: "Septiembre" },
  { value: "10", label: "Octubre" },
  { value: "11", label: "Noviembre" },
  { value: "12", label: "Diciembre" }
];

const yearOptions = years.map(year => ({
  value: year,
  label: year
}));

const hiddenIfNotFactura = values => values.tipoBusqueda !== "factura";
const hiddenIfFactura = values => values.tipoBusqueda === "factura";

export const formConfig: FormBuilderConfig<Inputs, Buttons> = {
  inputs: [
    {
      name: "tipoBusqueda",
      label: "* Tipo de Búsqueda",
      bts: { mCol: 3 },
      component: ISelectBuilder,
      props: {
        emptyLabel: "Por Periodo",
        data: [{ value: "factura", label: "Por Folio" }]
      }
    },
    {
      name: "mes",
      label: "Mes",
      bts: { mCol: 3 },
      component: ISelectBuilder,
      props: {
        emptyLabel: "Seleccione",
        data: monthOptions,
        hidden: hiddenIfFactura
      }
    },
    {
      name: "anio",
      label: "Año",
      bts: { mCol: 3 },
      component: ISelectBuilder,
      props: {
        emptyLabel: currentYear.toString(),
        data: yearOptions,
        hidden: hiddenIfFactura
      }
    },
    {
      name: "folioFactura",
      label: "Folio de Factura",
      bts: { mCol: 3 },
      component: ITextBuilder,
      props: {
        placeholder: "Folio de la factura",
        hidden: hiddenIfNotFactura
      }
    }
  ],
  buttons: [
    {
      name: "buscar",
      label: "Buscar",
      isSubmit: true,
      bts: { mCol: 3 },
      component: IButtonBuilder
    }
  ],
  validations: {
    folioFactura: {
      requiredIfFactura: {
        validator: (value, formValue) =>
          formValue.tipoBusqueda === "factura" && !value,
        message: () => "Ingrese el folio de la factura"
      }
    },
    mes: {
      requiredIfNotFactura: {
        validator: (value, formValue) =>
          formValue.tipoBusqueda !== "factura" && !value,
        message: () => "Seleccione el mes"
      }
    }
  },
  rows: [["tipoBusqueda", "mes", "anio", "folioFactura", "buscar"]]
};
